export class FileCache {
    src: string
    fnc: any

    constructor(src: string, fnc: any) {
        this.src = src;
        this.fnc = fnc;
    }

    get source() {
        return this.src
    }
}

export class MediaElements extends FileCache {
    static fnc: ((this: GlobalEventHandlers, ev: ProgressEvent) => any) | null;
    static src: string;

    constructor(src: string, fnc: any) {
        super(src, fnc);
    }

    setImage() {
        return new Promise((resolve, reject) => {
            let image = new Image();
            image.onprogress = this.fnc; // during loading process a loading progress can be triggered
            image.onload = () => resolve(this.src);
            image.onerror = () => reject(this.src);
            image.src = this.src;
        });
    }

    async setVideo() {
        let video = new Blob([this.src], {"type": "video\/mp4"})

        const videoUrl = URL.createObjectURL(video)
        
        return videoUrl
    }
}